import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import AppWhoppLogo from "@/assets/appwhoop_ticket_logo.webp";
import { scrollToTop } from "@/lib/utilsUI";

export default function Footer() {
  return (
    <footer className="flex flex-col justify-between items-center bg-aw-dark text-white px-4 pt-4 pb-32 sm:pb-4 sm:px-8 space-y-5">
      {/* Social media */}
      {/* 
          Facebook https://www.facebook.com/AppWhoop/
          Instagram https://www.instagram.com/appwhoop_ticket/
          X https://x.com/appwhoop
          TikTok https://www.tiktok.com/@appwhoop
          YouTube https://www.youtube.com/@appwhoop
          Twitch https://www.twitch.tv/appwhoop
          Spotify (Preparando)
          Linkeding (actualizando)
          WhatsApp https://wa.link/y3s99n 
        */}
      <div className="flex flex-row flex-wrap justify-center items-center mt-8 space-y-4 gap-y-4 gap-x-4 xl:gap-x-8">
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://www.facebook.com/AppWhoop"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            icon="fa-brands fa-facebook"
            className="text-[28px]"
          />
        </a>
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://www.instagram.com/appwhoop_com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            icon="fa-brands fa-instagram"
            className="text-[28px]"
          />
        </a>
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://x.com/appwhoop_com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            icon="fa-brands fa-x-twitter"
            className="text-[28px]"
          />
        </a>
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://www.tiktok.com/@appwhoop_com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon="fa-brands fa-tiktok" className="text-[28px]" />
        </a>
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://www.youtube.com/@appwhoop"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            icon="fa-brands fa-youtube"
            className="text-[28px]"
          />
        </a>
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://www.twitch.tv/appwhoop_com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon="fa-brands fa-twitch" className="text-[28px]" />
        </a>
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://open.spotify.com/playlist/2P2tJHlsiAD93liwoVdyBr?si=3CQAliGmTgaFApLBefUEpg"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            icon="fa-brands fa-spotify"
            className="text-[28px]"
          />
        </a>
        <a
          className="m-0 hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
          href="https://www.linkedin.com/company/appwhoop"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            icon="fa-brands fa-linkedin"
            className="text-[28px]"
          />
        </a>
      </div>
      {/* Navigation */}
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-12 gap-y-4 gap-x-8 w-full text-center text-sm mt-2 px-5 xl:px-20 xl:grid-rows-none">
        <div className="lg:col-span-4 xl:col-start-1 xl:col-span-4 xl:mr-6 2xl:col-span-2 2xl:col-start-2">
          <LazyLoadImage
            alt="AppWhoop Logo"
            effect="blur"
            wrapperProps={{
              style: {
                transitionDelay: "0.3s",
                maxWidth: "120px",
                margin: "0 auto",
              },
            }}
            src={AppWhoppLogo}
            className="w-full h-auto object-contain"
          />
          <p>
            Somos una plataforma de Administración, Gestión y Venta de Tickets
            Digitales.
          </p>
        </div>
        {/* Usa AppWhoop */}
        {/* <div className="flex flex-col space-y-1 text-left sm:text-left">
          <h4 className="font-extrabold mb-2">
            Usa AppWhoop
            <p className="text-xs font-medium">(Próximamente)</p>
          </h4>
          <a href="#" target="_blank" rel="noopener noreferrer">
            App Android
          </a>
          <a href="#" target="_blank" rel="noopener noreferrer">
            App iOS
          </a>
        </div> */}
        {/* Ofrecemos */}
        <div className="grid grid-cols-2 grid-rows-2 gap-y-12 sm:gap-y-8 lg:grid-rows-1 gap-x-8 lg:col-span-8 lg:grid-cols-4">
          <div className="sm:col-span-2 xl:col-span-1 flex flex-col space-y-1 text-left">
            <h4 className="font-extrabold">Ofrecemos</h4>
            <span className="italic tracking-wide">Ventas de Ticket</span>
            <span className="italic tracking-wide">Escaneo de QR</span>
            <span className="italic tracking-wide">Gestión de Tickets</span>
            <span className="italic tracking-wide">Alianzas y Partners</span>
          </div>
          {/* Empleos */}
          <div className="sm:col-span-2 xl:col-span-1 flex flex-col space-y-1 text-left">
            <h4 className="font-extrabold">Empleos</h4>
            <a
              href="https://forms.gle/bPQoq46UFXfzTxHy9"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
            >
              Embajadores
            </a>
            <a
              href="https://forms.gle/bPQoq46UFXfzTxHy9"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
            >
              Ejecutivos comerciales
            </a>
            <a
              href="https://forms.gle/bPQoq46UFXfzTxHy9"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
            >
              Influencers
            </a>
            <a
              href="https://forms.gle/bPQoq46UFXfzTxHy9"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
            >
              Otros empleos
            </a>
          </div>
          {/* Planes */}
          <div className="sm:col-span-2 xl:col-span-1 flex flex-col space-y-1 text-left">
            <h4 className="font-extrabold">
              Planes{" "}
              <span className="text-[10px] bg-yellow-500 text-aw-bluedark rounded-2xl px-1 py-0.5 font-semibold italic">
                Pronto
              </span>
            </h4>
            <span>Freemium</span>
            <span>Emprende</span>
            <span>Premium</span>
          </div>
          {/* Soporte */}
          <div className="sm:col-span-2 xl:col-span-1 flex flex-col space-y-1 text-left">
            <h4 className="font-extrabold">Soporte</h4>
            {/* <a href="#">FAQ</a> */}
            <a
              href="mailto:info@appwhoop.com"
              className="hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
            >
              Soporte
            </a>
            <a
              href="https://wa.me/+56985775784?text=Hola%20AppWhoop%2C%20necesito%20ayuda%20con%20..."
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-aw-green duration-300 transition-colors leading-6 sm:leading-5"
            >
              Whatsapp
              <FontAwesomeIcon
                icon="fa-brands fa-whatsapp"
                className="text-green-500 ml-1"
              />
            </a>
          </div>
        </div>
      </div>
      {/* Pay methods */}
      <div>
        <div className="flex flex-row justify-center items-center mt-2 space-y-4 gap-x-4 xl:gap-x-8">
          <FontAwesomeIcon
            icon="fa-brands fa-cc-visa"
            size="2x"
            className="m-0"
          />
          <FontAwesomeIcon
            icon="fa-brands fa-cc-mastercard"
            size="2x"
            className="m-0"
          />
          <FontAwesomeIcon
            icon="fa-brands fa-google-pay"
            size="2x"
            className="m-0"
          />
          <FontAwesomeIcon
            icon="fa-brands fa-apple-pay"
            size="2x"
            className="m-0"
          />
        </div>
      </div>
      <hr className="border border-gray-600 my-2 w-full" />
      {/* Copyright and others */}
      <div className="flex flex-col sm:flex-row sm:justify-evenly items-center w-full">
        <div>
          <p className="text-xs text-left text-aw-bluegray">
            © {new Date().getFullYear()} AppWhoop. Todos los derechos
            reservados.
          </p>
        </div>
        <div className="flex flex-row sm:flex-row justify-center flex-wrap items-center gap-y-2 gap-x-4 space-x-4 space-y-2 sm:space-y-0 mt-2 sm:mt-0 text-aw-bluegray">
          <Link
            to={"/"}
            onClick={scrollToTop}
            className="text-xs m-0 hover:text-aw-green-75 transition-text duration-200"
          >
            Cookies
          </Link>
          <Link
            to={"/"}
            onClick={scrollToTop}
            className="text-xs m-0 hover:text-aw-green-75 transition-text duration-200"
          >
            Mapa del Sitio
          </Link>
          <Link
            to={"/politica-de-privacidad-y-terminos-y-condiciones"}
            onClick={scrollToTop}
            className="text-xs m-0 hover:text-aw-green-75 transition-text duration-200"
          >
            Política de Privacidad, Términos y Condiciones
          </Link>
        </div>
      </div>
    </footer>
  );
}
